<p>custom-loading-cell-rendered works!</p>
